import React from "react";
import { NavLink } from "react-router-dom";
import MobileIcon from "../../assets/images/homePage/phone_icon.svg";
import EmailIcon from "../../assets/images/homePage/email_icon.svg";
import HomeNewBannerImg from "../../assets/images/homePage/home-banner-img2.png";

const BannerSection = () => {

  const chipsStyle = {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '16px',
    color: '#333',
    fontSize: '12px',
    fontWeight: '500',
    margin: '4px',
    userSelect: 'none',
    transition: 'background-color 0.3s ease',
    border: '0.20000000298023224px solid #e3e6f0',
    backgroundColor: '#fff'
  }

  return (
    <>
      <section className="homeBannerWrapper topPageBanner" id="home">
        <div className="max-container">
          <div className="padd-90">

            <div className="grid-auto-fit align-items-center max-width950" style={{ "--grid-gap": "55px" }}>
              <div>
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  Automate Your <br />
                  <span className="text-primary-color">Hospitality Sales Process</span>
                </h1>

                <p className="heading18px roboto-regular text-color-131415 mb20">

                  Streamline lead management, build your reputation, and grow your hospitality business with our all-in-one sales automation platform.
                </p>

                <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexWrap: 'wrap' }} className="mb30">
                  <li className="roboto-regular" style={chipsStyle}>Lead Management</li>
                  <li className="roboto-regular" style={chipsStyle}>Web-to-Lead Forms</li> <br />
                  <li className="roboto-regular" style={chipsStyle}>1:1 Email</li>
                  <li className="roboto-regular" style={chipsStyle}>Real-time Alerts</li>
                </ul>

                {/* <div style={{ display: "flex", alignItems: "center" }} className="mb20">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-5 w-5 mr-2 text-hospitality-200" data-lov-id="src/components/features/HeroSection.tsx:64:4" data-lov-name="CheckCircle" data-component-path="src/components/features/HeroSection.tsx" data-component-line="64" data-component-file="HeroSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20mr-2%20text-hospitality-200%22%7D"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                  <span className="roboto-regular heading15px">Capture more leads with custom forms</span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }} className="mb20">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-5 w-5 mr-2 text-hospitality-200" data-lov-id="src/components/features/HeroSection.tsx:64:4" data-lov-name="CheckCircle" data-component-path="src/components/features/HeroSection.tsx" data-component-line="64" data-component-file="HeroSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20mr-2%20text-hospitality-200%22%7D"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                  <span className="roboto-regular heading15px">Respond faster with real-time notifications</span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }} className="mb30">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-5 w-5 mr-2 text-hospitality-200" data-lov-id="src/components/features/HeroSection.tsx:64:4" data-lov-name="CheckCircle" data-component-path="src/components/features/HeroSection.tsx" data-component-line="64" data-component-file="HeroSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20mr-2%20text-hospitality-200%22%7D"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                  <span className="roboto-regular heading15px">Build reputation with automated follow-ups</span>
                </div> */}

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Subscribe Now
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div>
                <img
                  src={HomeNewBannerImg}
                  className="img-responsive position-relative"
                  alt="Double Your Qualified Leads"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="contact-details common-shadow roboto-regular">
          <ul>
            <li>
              {" "}
              <a href="tel:+91-9625-981200">
                <img src={MobileIcon} alt="Call" /> &nbsp; +91-9625-981200
              </a>
            </li>
            <li>
              <a href="mailto:contact@beyondleadz.ai">
                <img src={EmailIcon} alt="Email" />
                &nbsp; contact@beyondleadz.ai
              </a>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
